export default __webpack_public_path__ + "static/media/banner-3.dcdda724.png";